const licenceInfo = [
  {
    title: 'Licenciamiento por Empleado',
    subtitle: 'Plan base',
    content: [
      'El licenciamiento del Plan Base Empleado tiene una duración de un año a partir de la fecha de inicio seleccionada por el usuario. Al adquirir un plan para un número específico de empleados, por ejemplo, 10, el usuario tendrá la capacidad de transmitir un máximo de 10 nóminas electrónicas por mes durante ese período de doce meses. Las Notas de Ajuste, ya sean de reemplazo o de eliminación, no se descontarán del plan base adquirido.',

      'El usuario puede seleccionar el mes en el que desea que comience la vigencia de su licencia. Puede elegir el mes inmediatamente anterior a la fecha de compra, el mes en curso o el mes inmediatamente posterior. Sin embargo, existen consideraciones importantes. Si la activación de la licencia se realiza un mes después de la fecha de compra, el usuario aún podrá elegir como inicio de vigencia el mes anterior, el mes actual o el mes posterior a la compra. Por ejemplo, si el plan se compra en enero de 2025, pero se activa en febrero de 2025, la transmisión de nóminas podrá iniciarse desde enero de 2025.',

      [
        'No obstante, si la activación del plan se retrasa por más de dos meses desde la fecha de compra, el sistema aplicará una restricción en la selección del inicio de vigencia. En este escenario, el usuario solo podrá activar el plan a partir del mes siguiente a la fecha de compra. Por ejemplo, si un usuario adquiere el plan en enero de 2025, pero decide activarlo hasta mayo de 2025, la transmisión de nóminas solo estará habilitada a partir de febrero de 2025.',
      ],

      [
        'El sistema permite adquirir un segundo plan base de empleados con una antelación máxima de 30 días con respecto a la fecha de vencimiento del plan actual. ',
        { type: 'bold', text: 'Sin embargo' },
        ', es crucial tener en cuenta que los planes base de empleados no pueden superponerse en su vigencia. El usuario deberá asegurarse de que el plan actual haya finalizado completamente su período de validez antes de comenzar a utilizar los beneficios del nuevo plan base adquirido.',
      ],

      {
        type: 'title',
        text: 'Empleados Adicionales',
      },

      'El licenciamiento adicional por empleado en este esquema se gestiona mediante un prorrateo.',

      [
        'El cálculo del costo de estos empleados adicionales se determina en función del ',
        { type: 'bold', text: 'número de meses restantes' },
        ' de la vigencia del plan base original. Por ejemplo, si a un plan base le restan ',
        { type: 'bold', text: 'seis meses' },
        ' de vigencia y se adquieren ',
        { type: 'bold', text: 'cinco empleados adicionales' },
        ', el prorrateo se realizará cobrando el costo de estos cinco empleados por los seis meses restantes del plan base. Es fundamental comprender que la ',
        {
          type: 'bold',
          text: 'vigencia de este plan adicional estará directamente ligada a la vigencia restante del plan base',
        },
        '.',
      ],

      [
        'Por consiguiente, este plan base adicional ',
        { type: 'bold', text: 'no tiene una vigencia fija de un año' },
        ', sino que su duración se limita al periodo de tiempo que aún esté vigente el plan base al momento de la adquisición de los empleados adicionales.',
      ],

      [
        'Si un usuario adquiere un empleado adicional ',
        { type: 'bold', text: 'el último día del mes' },
        ', se le habilitará el uso de dicho empleado únicamente para ese día, pero el cobro correspondiente se aplicará por el ',
        { type: 'bold', text: 'mes completo' },
        '.',
      ],
    ],
  },
  {
    title: 'Licenciamiento por Documento',
    subtitle: 'Plan base',
    content: [
      [
        'El licenciamiento del Plan Base por Documentos tiene una vigencia de ',
        { type: 'bold', text: 'un año calendario' },
        '. Al finalizar este período de doce meses, cualquier saldo de documentos no utilizados se perderá automáticamente, y el contador de documentos se restablecerá a cero. A diferencia del plan por empleado, las Notas de Ajuste que se realicen a las nóminas electrónicas, ya sean de reemplazo o eliminación, sí se descontarán del saldo total de documentos disponibles en el plan base.',
      ],

      'Adicionalmente, para la transmisión de nóminas correspondientes a meses anteriores a la fecha de compra o para la transmisión de nóminas futuras, el usuario deberá adquirir paquetes adicionales de documentos, los cuales le permitirán gestionar estas transmisiones específicas más allá del consumo normal de su plan base anual.',

      {
        type: 'title',
        text: 'Documentos Adicionales',
      },

      [
        'En este tipo de licencia por documento, cada compra de documentos tiene vigencia de ',
        { type: 'bold', text: 'un (1) año adicional' },
        ', ',
        { type: 'bold', text: 'sin embargo' },
        ', debe estar vigente el plan base, de lo contrario, no podrá usar los documentos. El plan base se adquiere en la landing de colnómina.',
      ],
    ],
  },
  {
    title: 'Licenciamiento Mixto',
    subtitle: 'Plan base',
    content: [
      [
        'El sistema determina el tipo de licencia para el descuento. Si la licencia es por Empleado, se permite transmitir un ',
        { type: 'bold', text: 'número ilimitado de notas de ajuste' },
        ' (reemplazo y eliminación), descontándose del contador de empleados. Colnómina siempre prioriza el descuento del plan base de empleados.',
      ],

      'Si un usuario con un plan base de empleados activo desde enero de 2025 ya transmitió nóminas para ese mes, no podrá transmitir nóminas de meses anteriores, ya que el año de licencia rige desde enero de 2025 en adelante.',

      'Para transmitir nóminas de meses anteriores, el usuario debe adquirir paquetes de DOCUMENTOS. Estos paquetes permiten la transmisión de nóminas de meses anteriores y futuros.',

      'Cada plan de licencia opera de forma independiente según su respectiva vigencia.',
    ],
  },
];
export default licenceInfo;
